import { render, staticRenderFns } from "./laiMap.vue?vue&type=template&id=36677423&scoped=true&"
import script from "./laiMap.vue?vue&type=script&lang=js&"
export * from "./laiMap.vue?vue&type=script&lang=js&"
import style0 from "./laiMap.vue?vue&type=style&index=0&id=36677423&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36677423",
  null
  
)

export default component.exports